
/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */
const processInclude = require('base/util');
const quickShopping = require('./components/quickShopping').assignQuickShopping;
const cartPage = require('./cart/cartPage');

let categoryDatalayer;
let initialDatalayer;

if (window.dataLayer) {
    if (window.datalayerVersion === 'ga4') {
        initialDatalayer = require('plugin-seo/dataLayerGA4/layers/globalData');
    }
} else {
    const globalDataCode = require('plugin-seo/dataLayerGA4/layers/globalData');
    window.dataLayer = [];
    globalDataCode.sentInitConsent();
    globalDataCode.collectConsentTrackingInfo();
}

$(document).ready(() => {
    processInclude(quickShopping);
    processInclude(cartPage);
    // DATALAYERS, CHECK SITE PREFERENCE gtmkey
    if (window.dataLayer) {
        processInclude(initialDatalayer);
        processInclude(categoryDatalayer);
    }
});
